/**
 * @generated SignedSource<<e436f5cdf2b7e98d359a17a4a837852a>>
 * @relayHash 70b126ef780eee2b40d7efe1f7039c87
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID fd7e3ba959f96f612e3e7d7f890f8ff65f6967f2bb210a93c416dfcb5c483cc8

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { CapacityPageTableQuery } from './CapacityPageTableQuery.graphql';

const node: PreloadableConcreteRequest<CapacityPageTableQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "fd7e3ba959f96f612e3e7d7f890f8ff65f6967f2bb210a93c416dfcb5c483cc8",
    "metadata": {},
    "name": "CapacityPageTableQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
